import { createApp } from 'vue'
import App from './App.vue'

// 引入全局样式
import '../public/index.css'

// 引入第三方UI库
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import locale from 'element-plus/lib/locale/lang/zh-cn'

/* PrimeVue */
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
/* FullCalendar */
import '@fullcalendar/common/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'
/* AG-Grid */
import "ag-grid-community/dist/styles/ag-grid.css"
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import "ag-grid-community/dist/styles/ag-theme-balham.css"
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css"
import "ag-grid-community/dist/styles/ag-theme-alpine.css"

// 引入添慧UI库
import twUI from 'tw-ui';
import '../public/tinway-ui.css'

// 引入路由
import router from './router'

import systemService from './services/system.service'
import dataService from './services/data.service'
import windowService from './services/window.service'
import userService from './services/user.service'
import httpService from './services/http.service'
import { serviceProvider as dsServiceProvider } from 'tw-data-source'
import { serviceProvider as uiServiceProvider } from 'tw-ui'

const application = {

    // 启动应用
    start: function() {

        // 加载项目的静态数据
        try {
            const project = require('/public/static/project.json')
            const menus = require('/public/static/menus.json')
            systemService.initData({ project, menus })   
        } catch (error) {
            console.error(error)
        }

        // 注入数据源所需的服务，用于数据源内部获取数据（数据绑定的下拉选择）
        dsServiceProvider.dataService = dataService

        // 注入组件库所需的服务
        uiServiceProvider.windowService = windowService
        uiServiceProvider.systemService = systemService
        uiServiceProvider.userService = userService
        uiServiceProvider.httpService = httpService
    
        const app = createApp(App)
    
        // 全局配置UI组件默认中文语言、小尺寸、弹窗的初始 z-index 为 2000
        app.use(ElementPlus, { locale, size: 'mini' /*, zIndex: 2000*/ })
    
        app.use(router).use(twUI).mount('#app')
    }
}
 
export default application